import LoginView from '@/components/views/Login';
import RegisterView from '@/components/views/Register';
import DashView from '@/components/Dash';
import DashboardView from '@/components/views/Dashboard';
import ProfileView from '@/components/views/Profile';
import WithdrawalView from '@/components/views/Withdrawal';
import DepositView from '@/components/views/Deposit';
import SupportView from '@/components/views/Support';
import TransactionView from '@/components/views/Transaction';
import NotFoundView from '@/components/404';
import Callback from '@/components/Callback';
import AuthService from '@/services/AuthService';

var requireAuth = function (to, from, next) {
  if (!AuthService.isLoggedIn()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    });
  } else {
    next();
  }
};

const routes = [{
  path: '/login',
  component: LoginView
}, {
  path: '/',
  component: LoginView
}, {
  path: '/register/:type',
  component: RegisterView,
}, {
  path: '/register/:type/:lang',
  component: RegisterView,
}, {
  path: '/client',
  component: DashView,
  beforeEnter: requireAuth,
  children: [{
      path: 'dashboard',
      alias: '',
      component: DashboardView,
      name: 'Dashboard',
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'profile',
      alias: '',
      component: ProfileView,
      name: 'Profile',
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'deposit/:amount',
      alias: '',
      component: DepositView,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'deposit',
      alias: '',
      component: DepositView,
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'withdrawal',
      alias: '',
      component: WithdrawalView,
      name: 'Withdrawal',
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'support',
      alias: '',
      component: SupportView,
      name: 'Support',
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'notification',
      alias: '',
      component: TransactionView,
      name: 'Deposit Notification',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'transaction/:status',
      alias: '',
      component: TransactionView,
      name: 'Transaction Result',
      meta: {
        requiresAuth: true
      }
    }
  ]
}, {
  path: '/callback',
  component: Callback
}, {
  path: '*',
  component: NotFoundView
}];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js